export const wikiSettingsKeys = {
  all: ['wiki-settings'] as const,
  installation: (installationId: number) =>
    [...wikiSettingsKeys.all, 'installation', installationId] as const,
  repository: (installationId: number, repositoryId: number) =>
    [...wikiSettingsKeys.installation(installationId), 'repository', repositoryId] as const,
};

export const wikiSettingsQueryKey = (
  installationId: number | null,
  repositoryId: number | null,
) => {
  if (!installationId) {
    return wikiSettingsKeys.all;
  }

  if (!repositoryId) {
    return wikiSettingsKeys.installation(installationId);
  }

  return wikiSettingsKeys.repository(installationId, repositoryId);
};
